/**
 * Replaces {{tag}} in the text with values from window or metadata object.
 * PHONE_NUMBER and BRANCH_NAME only use window.QuestionnaireFormData (no metadata fallback).
 * Other tags use metadata for pricing/service info.
 *
 * @param {string} text - The text containing {{tag}} placeholders.
 * @param {object} metadata - The object containing replacement values for pricing/service tags only.
 * @returns {string} - The text with placeholders replaced.
 */
export function replaceTemplateTags(text, metadata) {
  if (!text || typeof text !== 'string') return text;

  // Phone number and branch name only from window (never from metadata)
  const windowPhoneNumber =
    typeof window !== 'undefined'
      ? window.QuestionnaireFormData?.phoneNumber
      : undefined;
  // branchName: prefer window.QuestionnaireFormData.branchName (set via wp_localize_script),
  // but fall back to the data-branch-name DOM attribute on the root element, which is always
  // set from the shortcode's branch_name attribute even when the WP option is empty.
  const windowBranchName = (() => {
    if (typeof window === 'undefined') return undefined;
    const fromWindow = window.QuestionnaireFormData?.branchName;
    if (fromWindow && fromWindow !== 'null' && fromWindow !== '')
      return fromWindow;
    const fromDOM = document
      .getElementById('questionnaire-form-root')
      ?.getAttribute('data-branch-name');
    return fromDOM || undefined;
  })();

  const replaced = text.replace(/{{\s*([^}]+)\s*}}/g, (match, tag) => {
    const key = tag.trim();

    // Handle window-only tags
    if (key === 'PHONE_NUMBER') {
      return windowPhoneNumber &&
        windowPhoneNumber !== 'null' &&
        windowPhoneNumber !== ''
        ? windowPhoneNumber
        : '';
    }
    if (key === 'BRANCH_NAME') {
      return windowBranchName &&
        windowBranchName !== 'null' &&
        windowBranchName !== ''
        ? windowBranchName
        : '';
    }

    // All other tags use metadata (for pricing, services, etc.)
    if (metadata && typeof metadata === 'object') {
      return Object.prototype.hasOwnProperty.call(metadata, key)
        ? metadata[key]
        : '';
    }

    return '';
  });

  return replaced;
}
